module.exports = __webpack_public_path__ + "static/media/mykytasemenov.f5b36d58.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/mykytasemenov.webp
// module id = 709
// module chunks = 0